/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetIamPermissionRequest
 */
export interface GetIamPermissionRequest {
    /**
     * 
     * @type {string}
     * @memberof GetIamPermissionRequest
     */
    iamPermissionId: string;
}

export function GetIamPermissionRequestFromJSON(json: any): GetIamPermissionRequest {
    return GetIamPermissionRequestFromJSONTyped(json, false);
}

export function GetIamPermissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIamPermissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamPermissionId': json['iam_permission_id'],
    };
}

export function GetIamPermissionRequestToJSON(value?: GetIamPermissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_permission_id': value.iamPermissionId,
    };
}


